import { GidMatrix, IfcData } from "@/services/admin-services/models";
import { Discipline, UseCase } from "@/services/global-services/models";
import { DataTableColumnDefinition, DataTableData, DataTableFootnote, DataTableRow } from "../Models";

export interface DataTableState {
    title?: string;
    columns: DataTableColumnDefinition[];
    rows: DataTableRow[];
    footnotes: DataTableFootnote[];
    caption?: string;
    dataSource?: GidMatrix | IfcData;
    dataSourceType?: "gid" | "ifc";
    parsedDataSource: DataTableRow[];
    showGroupHeaderRows: boolean;
    hasPropertyLevel: boolean;
    useCases?: UseCase[];
    disciplines?: Discipline[];
    activeDisciplines: string[];
    readOnly: boolean;
    refreshCount: number;

    onChange: (data: DataTableData) => void;
    onFilterColumn: (column: DataTableColumnDefinition) => boolean;
    onFilterRow: (row: DataTableRow) => boolean;
    onFilterUseCase: (useCase: UseCase) => boolean;
}

export const initialState: DataTableState = {
    columns: [],
    rows: [],
    footnotes: [],
    dataSource: undefined,
    parsedDataSource: [],
    showGroupHeaderRows: false,
    hasPropertyLevel: false,
    activeDisciplines: [],
    readOnly: false,
    refreshCount: 0,
    onChange: () => undefined,
    onFilterColumn: () => false,
    onFilterRow: () => false,
    onFilterUseCase: () => false,
};
